export enum PageTitle {
  SYNLAB = "SYNLAB Access",
  ESTONIA = "SYNLAB Access",
  DEFAULT = "SYNLAB Access Account"
}
